const isIP = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/.test(window.location.hostname);

// Dynamic API URL resolution supporting root domain (surgix.io), subpaths (/demo/v1, /demo/v2), and local dev
export const API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || isIP
    ? `http://${window.location.hostname}:8005`
    : `${window.location.origin}/api`;

// Dynamic Hospital ID resolution based on subpath (/demo/v1 -> hospital 2, /demo/v2 -> hospital 3) or localStorage
export const getActiveHospitalId = () => {
  const pathname = window.location.pathname.toLowerCase();
  if (pathname.includes('/demo/v1')) return '2';
  if (pathname.includes('/demo/v2')) return '3';
  return localStorage.getItem('surgix_active_hospital_id') || '1';
};

export const setActiveHospitalId = (id) => {
  localStorage.setItem('surgix_active_hospital_id', String(id));
  window.dispatchEvent(new Event('hospital_change'));
};
